import { ServiceLocator } from '../../../app/ServiceLocator';
import { Messages } from '../../../codegen/Localize';
import { openReactConfirmationDialog } from '../../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../../commonInfra/dialogs/style/TabDialogWidth';
import { ISiteSettingsForServerAdmin } from '../../../settings/types/ISite';
import { L10n } from '../../L10n/L10n';
import { Set } from '../../models/Set';
import { Sites } from '../../resources/Sites';
import { IResult } from '../../ServerApi/types/IResponse';
import { ContentActionNotification, INotificationTranslationIds } from '../../services/ContentActionNotification';

function showActivateSitesActionDialog(sites: Set<ISiteSettingsForServerAdmin>): Promise<any> {

  const SitesService = ServiceLocator.get<Sites>('Sites');
  const ContentActionNotification = ServiceLocator.get<ContentActionNotification>('ContentActionNotification');
  const siteName: string = sites.first().settings.name;

  let dialogBody: string = Messages.confirmActivateSites({SITE_NAME: L10n.elideIfLong(siteName), ITEM_COUNT: sites.size(), ITEM_COUNT_LOC: L10n.localizedCount(sites.size())});
  const dialogInstance = openReactConfirmationDialog<string[], IResult>({
    title: Messages.activateSites(),
    message: dialogBody,
    actionName: Messages.activateButtonConfirm({ ITEM_COUNT: sites.size() , ITEM_COUNT_LOC: L10n.localizedCount(sites.size()) }),
    isActionDelete: false,
    action: SitesService.activate.bind(SitesService),
    paramsForAction: sites.keys(),
    dialogWidth: TabDialogWidth.width375px
  });

  dialogInstance.result.then((result: IResult) => {
    ContentActionNotification.notifyResult(sites, result.errors, notificationTranslationIds(), notificationTranslationValues(siteName));
  });

  return Promise.resolve(dialogInstance.result);
}

function notificationTranslationIds(): INotificationTranslationIds {
  return {
    successId: 'sitesActivateSuccess',
    errorId: 'sitesActivateFailed'
  };
}

function notificationTranslationValues(siteName: string): Object {
  return {
    SITE_NAME: L10n.elideIfLong(siteName)
  };
}

export const ActivateSitesAction = {
  showActivateSitesActionDialog
};
